import { render, staticRenderFns } from "./NewFeatured.vue?vue&type=template&id=249a7ec3&"
import script from "./NewFeatured.vue?vue&type=script&lang=js&"
export * from "./NewFeatured.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports